
import React, { Component } from "react";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Container
} from "reactstrap";
// core components
import SimpleHeader from "../../../../components/Headers/SimpleHeader";
import './HangMan.css';
import styled from 'styled-components';
import Digits from '../../../../components/hangman/Digits';
import Title from '../../../../components/hangman/Title';
import Diagram from '../../../../components/hangman/Diagram';
import GameOver from '../../../../components/hangman/GameOver';
import NewGame from '../../../../components/hangman/NewGame';
import axios from 'axios';
import { SERVER_API_URL } from '../../../../config/constants';

const Block = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
  min-height: 300px;
`;

const letters = /^[a-z0-9]+$/i;
const digits = document.getElementsByClassName('digit');
const winText = `You did it! Super awesome!`;
const loseText = 'Seriously? That was an easy one.';

class HangMan extends Component {

  state = {
    data: [],
    lose: false,
    currentTitle: 0,
    guesses: [],
    currentDiagram: 1,
    goodGuesses: [],
    missedLetters: [],
    newGame: true,
  };
  constructor(props) {
    super(props);
    this.getData();
  }

  componentDidMount() {
    const wrapper = document.getElementsByClassName('App')[0];
    // eslint-disable-next-line
    wrapper ? wrapper.focus() : null;
  }

  getData() {
    const promise1 = axios.get(SERVER_API_URL + 'api/glossary');
    const promise2 = 'ccl magic';
    Promise.all([promise1, promise2])
      .then(
        function(words) {
          console.log(words[0].data);

          const randomTitles = words[0].data.sort(() => {
            return 0.5 - Math.random();
          });
          return this.setState({ data: randomTitles });
        }.bind(this)
      );
  }

  getTitle() {
    const currentTitle = this.state.data[this.state.currentTitle].english.toLowerCase().split('(')[0];
    const title = [];

    for (let i = 0; i < currentTitle.length; i++) {
      if (letters.test(currentTitle[i]) || currentTitle[i] === ' ') {
        title.push(currentTitle[i]);
      }
    }
    return title.join('');
  }

  handleClick = e => {
    const letter = e.target.textContent.toLowerCase();
    return letter.length > 1 ? null : this.checkLetter(letter);
  };

  handleKeyUp = e => {
    const keyName = e.key;
    if (letters.test(keyName)) {
      return this.isDisabled(keyName) ? null : this.checkLetter(keyName);
    }
  };

  isDisabled(letter) {
    for (let i = 0; i < digits.length; i++) {
      if (digits[i].textContent === letter) {
        return digits[i].hasAttribute('disabled');
      }
    }
  }

  checkLetter = currentLetter => {
    if (this.state.guesses.length > 0) {
      this.state.guesses.map(
        letter =>
          letter === currentLetter
            ? null
            : this.setState({
                guesses: this.state.guesses.concat(currentLetter),
              })
      );
    } else {
      this.setState({
        guesses: this.state.guesses.concat(currentLetter),
      });
    }
    if (!this.getTitle().includes(currentLetter)) {
      this.updateImage();
    } else {
      this.setState(
        {
          goodGuesses: this.state.goodGuesses.concat(currentLetter),
        },
        function() {
          this.isWin();
        }
      );
    }
  };

  updateImage = () => {
    if (this.state.currentDiagram < 6) {
      this.setState({
        currentDiagram: this.state.currentDiagram + 1,
      });
    }
    return this.state.currentDiagram === 6 ? this.gameOver('lose') : null;
  };

  isWin() {
    const lettersList = this.getTitle()
      .replace(/ /g, '')
      .split('')
      .filter((value, index, self) => {
        return self.indexOf(value) === index;
      });
    return lettersList.sort().toString() ===
      this.state.goodGuesses.sort().toString()
      ? this.gameOver('win')
      : null;
  }

  gameOver = result => {
    if (result === 'lose') {
      this.setState({
        lose: true,
        newGame: false,
      });
      this.showRest();
    } else {
      this.setState({
        lose: false,
        newGame: false,
      });
    }
  };

  showRest() {
    const missedLetterList = this.getTitle()
      .split('')
      .filter(letter => !this.state.goodGuesses.includes(letter));
    this.setState({
      missedLetters: missedLetterList.join(''),
    });
  }

  onClickRetry() {
    this.setState({
      currentTitle: this.state.currentTitle + 1,
      guesses: [],
      currentDiagram: 1,
      goodGuesses: [],
      missedLetters: [],
      newGame: true,
    });
  }

  render() {
    return (
      <>
        <SimpleHeader name="Hang Man" parentName="Games" />
        <Container className="mt--6" fluid>
          <Card className="mb-4">
            <CardHeader>
              <h3 className="mb-0">Guess the word</h3>
            </CardHeader>
            <CardBody>
            <div className="App" tabIndex="1" onKeyUp={this.handleKeyUp}>
              {/* <Name>Hangman</Name>
              <SubTitle newGame={this.state.newGame}>Guess the word</SubTitle> */}
              {this.state.data.length > 0 && (
                <div>
                  <Block>
                    <GameOver
                      text={this.state.lose ? loseText : winText}
                      newGame={this.state.newGame}
                      isLose={this.state.lose}
                    />
                    <Diagram
                      currentDiagram={this.state.currentDiagram}
                      newGame={this.state.newGame}
                    />
                    <NewGame
                      onClick={this.onClickRetry.bind(this)}
                      newGame={this.state.newGame}
                    />
                  </Block>

                  <Title
                    content={this.getTitle()}
                    guesses={this.state.guesses}
                    missedLetters={this.state.missedLetters}
                  />
                  <h3>
                    {this.state.data[this.state.currentTitle].vietnamese.toLowerCase()}{" "}
                  </h3>
                  <Digits
                    guesses={this.state.guesses}
                    onClick={this.handleClick}
                    newGame={this.state.newGame}
                  />
                </div>
              )}
            </div>
            </CardBody>
          </Card>
        </Container>
      </>
    );
  }
}
export default HangMan;
